import TimeInput from "discourse/components/time-input";

export default TimeInput.extend({});
